import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { AppBar, Box, IconButton, Toolbar, Typography, useMediaQuery } from '@mui/material'
import { useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { MESSAGE_BACK_TO_HOME_MINI_APP, PARAM_IS_BACK_TO_HOME_MINI_APP } from '../../../constants/params'
import { useAppParamsContext } from '../../../context/AppParamsContext'
import { PATH } from '../../../constants/router'
import { getUrlParamValue } from '../../../helper/params'

const DEFAULT_PAGE_TITLES = {
  [PATH.TRAFFIC_VIOLATIONS_LOOKUP]: 'Tra cứu phạt nguội',
  '/tra-cuu-phat-nguoi': 'Tra cứu phạt nguội',
  '/ban-do-diem-nong-phat-nguoi': 'Bản đồ điểm nóng phạt nguội',
  '/gioi-thieu': 'Giới thiệu',
  '/lien-he': 'Liên hệ'
}

const DEFAULT_HOME_PATHS = ['/', PATH.TRAFFIC_VIOLATIONS_LOOKUP]

export default function HeaderMiniApp({
  hideBack = false,
  defaultHomePath = PATH.TRAFFIC_VIOLATIONS_LOOKUP,
  homeTitle = 'Tra cứu phạt nguội',
  pageTitles = DEFAULT_PAGE_TITLES,
  homePaths = DEFAULT_HOME_PATHS
}) {
  const history = useHistory()
  const { pathname } = useLocation()
  const isMobile = useMediaQuery('(max-width:600px)')
  const { isHeaderMiniAppExpand } = useAppParamsContext()

  const title = useMemo(() => {
    if (pathname === '/') return homeTitle
    if (pathname.startsWith('/chi-tiet-phat-nguoi')) return 'Chi tiết vi phạm'
    return pageTitles[pathname] || homeTitle
  }, [homeTitle, pageTitles, pathname])

  const rootPathSet = useMemo(() => {
    return new Set([...(homePaths || []), defaultHomePath].filter(Boolean))
  }, [defaultHomePath, homePaths])

  const handleBack = () => {
    const isHomePath = rootPathSet.has(pathname)
    
    // Nếu đang ở trang chi tiết và có cờ isBackToHomeMiniApp trên URL -> buộc thoát mini app luôn
    const forceBack = pathname.startsWith(PATH.TRAFFIC_VIOLATIONS_RESULT) && [1, true].includes(getUrlParamValue(PARAM_IS_BACK_TO_HOME_MINI_APP))

    if ((isHomePath || forceBack) && typeof window !== 'undefined' && window.parent) {
      window.parent.postMessage({ key: MESSAGE_BACK_TO_HOME_MINI_APP }, '*')
      return
    }

    history.goBack()
  }

  return (
    <AppBar
      position='sticky'
      elevation={0}
      sx={{
        backgroundColor: isMobile ? 'var(--v1-brand-primary)' : 'var(--v1-surface-card)',
        color: isMobile ? 'var(--v1-text-inverse)' : 'var(--v1-brand-primary)',
        borderBottom: isMobile ? 'none' : '1px solid #eee'
      }}>
      <Toolbar
        sx={{
          minHeight: isHeaderMiniAppExpand ? '80px !important' : '60px !important',
          height: isHeaderMiniAppExpand ? '80px !important' : '60px !important',
          padding: isMobile ? '0px' : '0px 12px',
          paddingTop: isHeaderMiniAppExpand ? '42px !important' : undefined
        }}>
        {!hideBack && (
          <IconButton
            onClick={handleBack}
            sx={{
              color: 'currentColor',
              position: 'absolute',
              left: 15,
              padding: 0,
              height: 24,
              width: 24
            }}>
            <ArrowBackIcon />
          </IconButton>
        )}

        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: isMobile ? '16px' : '20px',
              lineHeight: isMobile ? '28px' : '30px'
            }}>
            {title}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
